import React, { ProviderProps, useMemo, useState } from "react";

export type TripleOaksContext = {
    lair : boolean,
    setLair : React.Dispatch<React.SetStateAction<boolean>>,
    revealed : boolean,
    setRevealed : React.Dispatch<React.SetStateAction<boolean>>
};

const context = React.createContext<TripleOaksContext>({
    lair : false,
    setLair : (b) => {},
    revealed : false,
    setRevealed : (b) => {}
});

const TripleOaksProvider = ({ children } : ProviderProps<any>) => {
    const [lair, setLair] = useState(false);
    const [revealed, setRevealed] = useState(false);

    const value : TripleOaksContext = useMemo(() => ({ lair, setLair, revealed, setRevealed }), [ lair, setLair, revealed, setRevealed ]);

    return (
        <context.Provider value={value}>
            {children}
        </context.Provider>
    );
};

TripleOaksProvider.context = context;

export default TripleOaksProvider;